import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FaqComponent } from './faq.component';
import { LanguageInterceptor } from '../shared/language-interceptor.service';


@NgModule({
  providers:[LanguageInterceptor],
  imports: [
    RouterModule.forChild([
      { path: ':language/frequently-asked-questions', component:FaqComponent, canActivate:[LanguageInterceptor], data:{localeTag: 'FAQ_URL'}},
      { path: ':language/preguntas-frecuentes', component:FaqComponent, canActivate:[LanguageInterceptor], data:{localeTag: 'FAQ_URL'}},
      { path: ':language/foire-aux-questions', component:FaqComponent, canActivate:[LanguageInterceptor], data:{localeTag: 'FAQ_URL'}},
      { path: ':language/domande-frequenti', component:FaqComponent, canActivate:[LanguageInterceptor], data:{localeTag: 'FAQ_URL'}},
      { path: ':language/haufig-gestellte-fragen', component:FaqComponent, canActivate:[LanguageInterceptor], data:{localeTag: 'FAQ_URL'}},
    ])
  ]
})
export class FaqRoutingModule { 

    
}
